import { render, staticRenderFns } from "./venderbatchupdate.vue?vue&type=template&id=2fa39be4&scoped=true&"
import script from "./venderbatchupdate.vue?vue&type=script&lang=js&"
export * from "./venderbatchupdate.vue?vue&type=script&lang=js&"
import style0 from "./venderbatchupdate.vue?vue&type=style&index=0&id=2fa39be4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa39be4",
  null
  
)

export default component.exports